export default __webpack_public_path__ + "static/media/background.78086c1b.png";